<template>
    <el-row
      v-if="config"
      :gutter="config.gutter"
      :justify="config.justifyContent"
      :align="config.alignItems"
      :style="rowStyle"
      type="flex"
      class="row-wrap"
    >
      <Col
        v-if="config.children && config.children.length"
        v-for="(item, colIdx) in config.children"
        :key="colIdx"
        :currentElementIndex="currentElementIndex"
        :allArcListMap="allArcListMap"
        :idx="colIdx"
        :listLength="config.children.length"
        :parentKeys="[...parentKeys, idx]"
        :disabled="disabled"
        :config="item.config"
      ></Col>
    </el-row>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import { useElementIndex } from './uses/elementIndexUse'; // 引入 composable
  import Col from './Col.vue'; // 假设你有 Col 组件
  
  // 获取 props
  const props = defineProps({
    allArcListMap: { type: Object, default: () => ({}) },
    currentElementIndex: { type: Array, default: () => [] },
    idx: { type: Number, default: -1 },
    parentKeys: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: true },
    config: { type: Object },
  });
  
  // 使用 useElementIndex 来复用逻辑
  const { componentName, currentElementIndexStr, itemIdxStr } = useElementIndex(props);
  
  // 计算样式
  const rowStyle = computed(() => {
    return {
      flexWrap: props.config.isNoWrap ? 'nowrap' : 'wrap',
      width: props.config.width ? `${props.config.width}px` : undefined,
      height: props.config.height ? `${props.config.height}px` : undefined,
    };
  });
  </script>
  
  <style scoped>
  .row-wrap {
    /* 可以根据需要自定义行的样式 */
  }
  </style>
  